import { useAbility } from '@cast/shared-ability-data-access';

export const useGpuMetricsFlag = () => {
  return useAbility().can('view', 'FeatureGpuMetrics');
};
